import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useCatalogCategory, CatalogCategory } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<CatalogCategory>
      useData={useCatalogCategory}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
